module.exports = __webpack_public_path__ + "static/media/remote.36e47a68.jpg";